import React from 'react'
import { Button, Form, Input, Card, message, Modal, Spin , Row, Col,DatePicker,Checkbox ,Select, Avatar,Alert } from 'antd'
import fetch from '../services/fetch'
import service from './../services';
import ciqa  from './../components/ciqa'
import moment from 'moment';
import reqwest from 'reqwest';

const { Meta } = Card;
class Register extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            schoolLogo: '',
            id : '',
            schoolName : '',
            schoolLogo : '',
            superDepartment: '',
            organization : '',
            establishTime : undefined,
            address : '',
            code : '',
            organizationType : '',
            authorizedNumber : '',
            fullTimeStuff : {
                count: "",
                zg: "",
                fg: "",
                zj: "",
                doctor: "",
                master: "",
                age: ""
            },
            mainResponsibility:{
                other: false,
                main: [],
                text: ""
            },
            organizationStructure: {
                other: false,
                main: [],
                text: ""
            },
            organizationNature: {
                other: false,
                main: [],
                text: ""
            },
            organizationPrincipal: {
                name: "",
                duty: "",
                sex: "",
                degree: "",
                tel: "",
                email: ""
            },
            organizationResponsibity : '',
            presentMainWork : '',
            workFeather : '',
            schoolSuggestion: '',
            secretSuggestion: '',
            file : '',
            fileList : '',
            loading: false
        }
    }

    
    componentDidMount() {
        service.account.website().then(data => {
            sessionStorage.setItem('website', JSON.stringify(data));
            document.title = data.systemName;
            this.setState(Object.assign({}, this.state, data));
        });
    }
    

    handleOk() {
        this.props.form.validateFields((err, values)=> {

            const formData = new FormData();
            
            if(!err) {
                this.setState({
                    loading: true
                })
                // let data = this.props.form.getFieldsValue()
                let loginName = values.loginName ? values.loginName : ''
                let p =  values.pwd  ? values.pwd : ''
                let realName = values.realName  ? values.realName : ''
                let email = values.email ? values.email : ''
                let phone = values.phone ? values.phone : ''
                //入盟申请信息
                let superDepartment = values.superDepartment ? values.superDepartment : ''
                let organization = values.organization ? values.organization : ''
                let establishTime = this.state.establishTime ? this.state.establishTime : ''
                let address = values.address ? values.address : ''
                let code = values.code ? values.code : ''
                let organizationType = values.organizationType ? values.organizationType : ''
                let authorizedNumber = values.authorizedNumber ? values.authorizedNumber : ''
                //现有专职人员
                let count = values.count ? values.count : ''
                let doctor = values.doctor ? values.doctor : ''
                let master = values.master ? values.master : ''
                let zg = values.zg ? values.zg : ''
                let fg = values.fg ? values.fg : ''
                let age = values.age ? values.age : ''
                let zj = values.zj ? values.zj : ''
                let fullTimeStuff = Object.assign({
                    count : count ,
                    doctor : doctor ,
                    master : master ,
                    zg : zg ,
                    zj : zj,
                    fg : fg ,
                    age : age
                })
                //主要职能业务范围
                let mainResponsibility = this.state.mainResponsibility ? this.state.mainResponsibility : ''
                let mainResponsibilityOther = values.mainResponsibilityOther ? values.mainResponsibilityOther : ''
                //组织架构
                let organizationStructure = this.state.organizationStructure ? this.state.organizationStructure : ''
                let organizationStructureOther = values.organizationStructureOther ? values.organizationStructureOther : ''
                //机构主要负责人
                let name = values.name ? values.name : ''
                let duty = values.duty  ? values.duty : ''
                let sex = values.sex  ? values.sex : ''
                let degree = values.degree  ? values.degree : ''
                let tel = values.tel ? values.tel : ''
                let organizationPrincipalEmail = values.organizationPrincipalEmail ? values.organizationPrincipalEmail : ''
                let organizationPrincipal = Object.assign({} , {
                    name : name ,
                    duty : duty ,
                    sex : sex ,
                    degree : degree ,
                    tel : tel ,
                    email : organizationPrincipalEmail
                })
                //机构性质
                let organizationNature = this.state.organizationNature ? this.state.organizationNature : ''
                let organizationNatureOther = values.organizationNatureOther ? values.organizationNatureOther : ''
                //机构职责
                let organizationResponsibity = values.organizationResponsibity ? values.organizationResponsibity : ''
                //目前开展的工作
                let presentMainWork = values.presentMainWork ? values.presentMainWork : ''
                //workFeather
                let workFeather = values.workFeather  ? values.workFeather : ''
                //schoolSuggestion
                let schoolSuggestion = values.schoolSuggestion ? values.schoolSuggestion : ''

                //赋值 formData
                formData.append("loginName",loginName);
                formData.append("pwd",p);
                formData.append("realName",realName);
                formData.append("email",email);
                formData.append("phone",phone);

                formData.append("organization",organization)
                formData.append("superDepartment",superDepartment)
                formData.append("establishTime",establishTime != undefined ? establishTime : '')
                formData.append("address",address)
                formData.append("code",code)
                formData.append("organizationType",organizationType)
                formData.append("authorizedNumber",authorizedNumber)
                formData.append("fullTimeStuff",JSON.stringify(fullTimeStuff))
                formData.append("mainResponsibility" , JSON.stringify(mainResponsibility))
                formData.append("mainResponsibilityOther" , mainResponsibilityOther)
                formData.append("organizationStructure" , JSON.stringify(organizationStructure))
                formData.append("organizationStructureOther" , organizationStructureOther)
                formData.append("organizationPrincipal", JSON.stringify(organizationPrincipal))
                formData.append("organizationNature",JSON.stringify(organizationNature))
                formData.append("organizationNatureOther",organizationNatureOther)
                formData.append("organizationResponsibity",organizationResponsibity)
                formData.append("presentMainWork", presentMainWork)
                formData.append("workFeather",workFeather)
                formData.append("schoolSuggestion",schoolSuggestion)

                if(this.state.file != '' && this.state.file != undefined){
                    formData.append("files",this.state.file)
                }

                reqwest({
                    url: fetch.base + 'ciqamembercollectinfo/register',
                    method: 'post',
                    processData: false,
                    data: formData,
                    crossOrigin: true,
                    withCredentials: true,
                    success:(response) =>{
                       let code = JSON.parse(response).code
                       if(code == 200){
                        Modal.success({
                            title: '注册成功',
                            content: '注册成功，点击确认前往登录页面',
                            okText: '确认',
                            onOk: () => {
                                window.location.hash = "/";
                                window.location.reload();
                            }
                        })
                       }else if(code == 400 || code == 500){
                            Modal.error({
                                title:'提示',
                                content:JSON.parse(response).message,
                                okText:'确认',
                                onOk : ()=>{
                                } 
                            })
                       }
                       
                    },
                    error:() =>{
                        Modal.info({
                            title:'提示',
                            content:'注册失败！',
                            okText:'确认',
                            onOk : ()=>{
                            } 
                        })
                        this.setState({
                            loading: false
                        })
                    }
                })

                // fetch.post("/employee/register", data).then(data => {
                //     if(data.payload.data === 1) {
                //         Modal.success({
                //             title: '注册成功',
                //             content: '注册成功，点击确认前往登录页面',
                //             okText: '确认',
                //             onOk: () => {
                //                 window.location.hash = "/";
                //                 window.location.reload();
                //             }
                //         })
                //     } else {
                //         message.error(data.message)
                //     }
                //     this.setState({
                //         loading: false
                //     })
                // })
            }
        })
    }

    
    handlePictureChange(data){
        let file = data.file
        let fileList = data.fileList
        this.setState({
            fileList : fileList,
            file : file
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: 24,
                sm: { span: 2 }

            },
            wrapperCol: {
                xs: 24,
                sm: { 
                    span: 16, 
                    offset: 1
                 }
            }
        }

        const a = [
            {
                label: '独立设置机构',
                value: 1
            },
            {
                label: '隶属于教务处',
                value: 2
            },
            {
                label: '与教师发展中心合署办公',
                value: 3
            },
            {
                label: '与发展规划处合署办公',
                value: 4
            },
            {
                label: '其他（请具体说明）',
                value: 5
            }
        ]
        const b = [
            {
                label: '机构有独立的领导班子',
                value: 1
            },
            {
                label: '机构领导由教务处长兼任',
                value: 2
            },
            {
                label: '机构领导由校领导兼任',
                value: 3
            },
            {
                label: '机构领导兼其它部门领导',
                value: 4
            },
            {
                label: '其他（请具体说明）',
                value: 5
            }
        ]
        const c = [
            {
                label: '教学督导',
                value: 1
            },
            {
                label: '专项评估',
                value: 2
            },
            {
                label: '数据监测',
                value: 3
            },
            {
                label: '教师培训',
                value: 4
            },
            {
                label: '业务限于校内',
                value: 5
            },
            {
                label: '兼顾校外服务',
                value: 6
            },
            {
                label: '其他（请具体说明）',
                value: 7
            },
        ]
        const inputStyle = {
            width: '80%'
        }
        return (
            <div className="div-reister">
                <Spin tip="加载中..." spinning={this.state.loading}>
                    <Form layout="horizontal" {...formItemLayout}  className="register-card-form">
                        <Card  className="div-register-card">
                        {/* title="请填写注册信息" */}
                        <Meta
                            avatar={
                            <Avatar src={`http://qa.gxjxcp.net/admin/logo-ciqa.png`}/>
                            }
                            title={<Alert message="如果您有账号，请点击返回，直接登录；若没有账号，请您先完成注册再登录系统" type="warning" />}
                            style={{marginBottom:10}}
                        />
                        <Row gutter={24}>
                            <Col span={24}>
                                <Form.Item label="登录账号">
                                    { 
                                        getFieldDecorator('loginName', {
                                            rules: [
                                                {
                                                    min: 4,
                                                    message: `登录账号长度最少为4`
                                                }, 
                                                {
                                                    required: true,
                                                    message: `请输入登录账号`
                                                },
                                                {
                                                    validator: (rule, value, callback) =>{
                                                        if(value === '') {
                                                            callback('请输入登录账号')
                                                            return
                                                        }
                                                        fetch.get("/employee/checkLoginName/" + value).then(data => {
                                                            if(data.payload.data) {
                                                                callback('登录账号已经存在')
                                                            } else {
                                                                callback()
                                                            }
                                                        })
                                                    }
                                                }
                                            ]
                                        })(
                                            <Input />        
                                        )
                                    }
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={24}>
                                <Form.Item label="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;密码">
                                    { 
                                        getFieldDecorator('pwd', {
                                            rules : [
                                                {
                                                    required: true,
                                                    message: `请输入密码`
                                                },
                                                {
                                                    min: 6,
                                                    message: '密码最小长度为6'
                                                }
                                            ]
                                        })(
                                            <Input type='password' />        
                                        )
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={24}>
                                <Form.Item label="确认密码">
                                    { 
                                        getFieldDecorator('pwd2', {
                                            rules : [
                                                {
                                                    required: true,
                                                    message: `请输入密码`
                                                },
                                                {
                                                    min: 6,
                                                    message: '密码最小长度为6'
                                                },
                                                {
                                                    validator: (rule, value, callback) =>{
                                                        let p = this.props.form.getFieldValue('pwd')
                                                        if(value !== p) {
                                                            callback('两次密码不一致')
                                                        } else {
                                                            callback()
                                                        }
                                                    }
                                                }
                                            ]
                                        })(
                                            <Input type='password' />        
                                        )
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={24}>
                                <Form.Item label="学校名称">
                                { 
                                    getFieldDecorator('realName', {
                                        rules: [
                                            {
                                                required: true,
                                                message: `请输入学校名称`
                                            }, 
                                            {
                                                validator: (rule, value, callback) =>{
                                                    if(value === '') {
                                                        callback('请输入学校名称')
                                                        return
                                                    }
                                                    fetch.get("/employee/checkrealname/" + value).then(data => {
                                                        if(data.payload.data) {
                                                            callback('系统中存在此学校')
                                                        } else {
                                                            callback()
                                                        }
                                                    })
                                                }
                                            }
                                        ]
                                    })(
                                        <Input />        
                                    )
                                }
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={24}>
                                <Form.Item label="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邮箱">
                                    { 
                                        getFieldDecorator('email', {
                                            rules : [
                                                {
                                                    pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                                                    message: '请输入正确的邮箱格式'
                                                }
                                            ]
                                        })(
                                            <Input />        
                                        )
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={24}>
                                <Form.Item label="&nbsp;&nbsp;&nbsp;电话号码">
                                    { 
                                        getFieldDecorator('phone')(
                                            <Input />        
                                        )
                                    }
                                </Form.Item>
                            </Col>
                        </Row>    
                    </Card>
                    
                    <Card className="div-entryciqa-card" title="请填写入盟申请" >
                        <Row gutter={24}>
                            <Col span={12}>
                                <Row>
                                    <Form.Item style={{marginTop: '10px'}} label="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;学校名称">
                                    { 
                                        getFieldDecorator('realName', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: `请输入学校名称`
                                                }, 
                                                {
                                                    validator: (rule, value, callback) =>{
                                                        if(value === '') {
                                                            callback('请输入学校名称')
                                                            return
                                                        }
                                                        fetch.get("/employee/checkrealname/" + value).then(data => {
                                                            if(data.payload.data) {
                                                                callback('系统中存在此学校')
                                                            } else {
                                                                callback()
                                                            }
                                                        })
                                                    }
                                                }
                                            ]
                                        })(
                                            <Input />        
                                        )
                                    }
                                    </Form.Item>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <Form.Item label="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上级主管部门" >
                                            { 
                                                getFieldDecorator('superDepartment', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: `请输入上级主管部门名称`
                                                        }
                                                    ]
                                                })(
                                                    <Input />        
                                                )
                                            }
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row gutter={24}>
                                    <Col span={8}>
                                        <div style={{color:'black', marginTop:'15px'}}> 学校徽标(LOGO,支持PNG,GIF,JPG格式)</div>
                                    </Col>
                                    <Col span={16}>
                                        <ciqa.CiqaPicturesWall fileList={this.state.fileList} handChange={this.handlePictureChange.bind(this)}>
                            
                                        </ciqa.CiqaPicturesWall>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        
                        <Row gutter={24}>
                            <Col span={12}>
                                <Form.Item label="质量管理机构名称">
                                    { 
                                        getFieldDecorator('organization', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: `请输入质量管理机构名称`
                                                }
                                            ]
                                        })(
                                            <Input />        
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;成立时间">
                                    { 
                                        getFieldDecorator('establishTime')(
                                            <DatePicker
                                            value={this.state.establishTime ? moment(this.state.establishTime, "YYYY-MM-DD") :  moment(new Date(), "YYYY-MM-DD")}
                                            placeholder="选择时间"
                                            onChange={(date, str) => {
                                                this.setState({
                                                    establishTime: str
                                                })
                                            }}
                                        />    
                                        )
                                    }
                                </Form.Item>
                            </Col>
                        </Row> 

                        <Row gutter={24}>
                            <Col span={12}>
                            <Form.Item label="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系地址">
                                { 
                                    getFieldDecorator('address' , {
                                        rules : [
                                        {
                                            max: 100,
                                            message: '联系地址最大长度100'
                                        }
                                    ]
                                    })(
                                        <Input />        
                                    )
                                }
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邮编">
                                { 
                                    getFieldDecorator('code',{
                                        rules : [
                                            {
                                                pattern: /^[0-9]{6}$/,
                                                message: '请输入正确的邮编格式'
                                            }
                                        ]
                                    })(
                                        <Input />        
                                    )
                                }
                                </Form.Item>
                            </Col>
                        </Row> 

                         <Row gutter={24}>
                            <Col span={12}>
                            <Form.Item label="&nbsp;&nbsp;&nbsp;质量管理机构类型">
                                { 
                                    getFieldDecorator('organizationType')(
                                        <Select
                                            placeholder="请选择类型..."
                                            allowClear
                                            style={{width:'80%'}}
                                            value={this.state.organizationType}
                                            onChange={(value)=>{
                                                if(value != undefined){
                                                    this.setState({
                                                        organizationType : value
                                                    })
                                                }
                                            }}
                                        >
                                            <Select.Option key={"1"}>独立设置</Select.Option>
                                            <Select.Option key={"2"}>教务处分支机构</Select.Option>
                                            <Select.Option key={"3"}>其他部分分支机构</Select.Option>
                                        </Select>    
                                    )
                                }
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;核定编制数">
                                { 
                                    getFieldDecorator('authorizedNumber',{
                                        rules : [
                                            {
                                                message:'只能输入数字',
                                                pattern: /^[0-9]+$/
                                            }
                                        ]
                                    })(
                                        <Input />        
                                    )
                                }
                                </Form.Item>
                            </Col>
                        </Row> 

                            <Row>
                            <Col span={3}>
                                <div style={{paddingTop: 65 , color:'black'}}>
                                    现有专职人员    
                                </div>
                            </Col>
                             <Col span={21}>
                                <Row gutter={24}>
                                    <Col span={10}>
                                    <Form.Item label="总数">
                                        { 
                                            getFieldDecorator('count',{
                                                rules : [
                                                    {
                                                        message:'请输入合法数字',
                                                        pattern: /^[0-9]+$/
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    placeholder="请填写" 
                                                    suffix="人"
                                                ></Input>      
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                    <Col span={10}>
                                        <Form.Item label="博士">
                                        { 
                                            getFieldDecorator('doctor',{
                                                rules : [
                                                    {
                                                        message:'请输入合法数字',
                                                        pattern: /^[0-9]+$/
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    placeholder="请填写" 
                                                    suffix="人"
                                                ></Input>             
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                </Row> 

                                <Row gutter={24}>
                                    <Col span={10}>
                                    <Form.Item label="硕士">
                                        { 
                                            getFieldDecorator('master',{
                                                rules : [
                                                    {
                                                        message:'请输入合法数字',
                                                        pattern: /^[0-9]+$/
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    placeholder="请填写" 
                                                    suffix="人"
                                                ></Input>      
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                    <Col span={10}>
                                        <Form.Item label="正高">
                                        { 
                                            getFieldDecorator('zg',{
                                                rules : [
                                                    {
                                                        message:'请输入合法数字',
                                                        pattern: /^[0-9]+$/
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    placeholder="请填写" 
                                                    suffix="人"
                                                ></Input>             
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                </Row> 

                                <Row gutter={24}>
                                    <Col span={10}>
                                    <Form.Item label="副高">
                                        { 
                                            getFieldDecorator('fg',{
                                                rules : [
                                                    {
                                                        message:'请输入合法数字',
                                                        pattern: /^[0-9]+$/
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    placeholder="请填写" 
                                                    suffix="人"
                                                ></Input>      
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                    <Col span={10}>
                                        <Form.Item label="中级">
                                        { 
                                            getFieldDecorator('zj',{
                                                rules : [
                                                    {
                                                        message:'请输入合法数字',
                                                        pattern: /^[0-9]+$/
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    placeholder="请填写" 
                                                    suffix="人"
                                                ></Input>             
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                </Row>

                                 <Row gutter={24}>
                                    <Col span={10}>
                                    <Form.Item label="平均年龄">
                                        { 
                                            getFieldDecorator('age',{
                                                rules : [
                                                    {
                                                        message:'请输入合法数字',
                                                        pattern: /^[0-9]+$/
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    placeholder="请填写" 
                                                    suffix="岁"
                                                ></Input>      
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                    
                                </Row>  
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={3}>
                                <div style={{marginTop:10,color:'black'}}>
                                    主要职能业务范围(打“√”)
                                </div>
                            </Col>
                            <Col span={21}>
                                <Form.Item label="">
                                    { 
                                        getFieldDecorator('mainResponsibility')(
                                            <Checkbox.Group
                                                style={{paddingTop: 10, paddingBottom: 10 }}
                                                options={c}
                                                onChange={(options) => {
                                                    const flg = options.some(option => option === 7)
                                                    this.setState({
                                                        mainResponsibility: {
                                                            ...this.state.mainResponsibility,
                                                            other: flg,
                                                            main: options
                                                        }
                                                    })
                                                }}
                                            />
                                        )
                                    }
                                </Form.Item>
                                {
                                    this.state.mainResponsibility.other ?
                                        <Form.Item labelCol={{ span: 2 }} wrapperCol={{ span: 6 }} label="具体说明">
                                            {
                                                getFieldDecorator('mainResponsibilityOther',{

                                                    rules : [
                                                        {
                                                            max : 200 ,
                                                            message : '内容不能过长'
                                                        }
                                                    ]

                                                })(
                                                    <Input
                                                        value={this.state.mainResponsibility.text}
                                                        placeholder="请填写"
                                                        onChange={(event) => {
                                                            this.setState({
                                                                mainResponsibility: {
                                                                    ...this.state.mainResponsibility,
                                                                    text: event.target.value
                                                                }
                                                            })
                                                        }}
                                                    ></Input>
                                                )
                                            }
                                        </Form.Item> : ""
                                }
                            </Col>
                        </Row> 

                        <Row gutter={24}>
                            <Col span={3}>
                                <div style={{marginTop:10,color:'black'}}>
                                 组织架构(领导班子)(打“√”)
                                </div>
                            </Col>
                            <Col span={21}>
                            <Form.Item label="">
                                { 
                                    getFieldDecorator('organizationStructure')(
                                        <Checkbox.Group
                                            style={{paddingTop: 10, paddingBottom: 10 }}
                                            value={this.state.organizationStructure.main}
                                            options={b}
                                            onChange={(options) => {
                                                const flg = options.some(option => option === 5)
                                                this.setState({
                                                    organizationStructure: {
                                                    ...this.state.organizationStructure,
                                                    other: flg,
                                                    main: options
                                                }
                                            })
                                            }}
                                        />  
                                    )
                                }
                            </Form.Item>
                                    {
                                        this.state.organizationStructure.other ?
                                        <Form.Item labelCol={{ span: 2 }} wrapperCol={{ span: 6 }} label="具体说明">
                                            {
                                                getFieldDecorator('organizationStructureOther',{
                                                    rules : [
                                                        {
                                                            max : 200 ,
                                                            message : '内容不能过长'
                                                        }
                                                    ]
                                                })(
                                                <Input
                                                    value={this.state.organizationStructure.text}
                                                    placeholder="请填写"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            organizationStructure: {
                                                                ...this.state.organizationStructure,
                                                                text: event.target.value
                                                            }
                                                        })
                                                    }}
                                                ></Input>
                                                )
                                            }
                                        </Form.Item> : ""
                                    }
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={3}>
                                <div style={{paddingTop: 50,color:'black'}}>
                                    机构主要负责人
                                </div>
                            </Col>
                            <Col span={21}>
                                <Row gutter={24}>
                                    <Col span={10}>
                                    <Form.Item label="姓名">
                                        { 
                                            getFieldDecorator('name',{
                                                rules :[
                                                    {
                                                        max : 20 ,
                                                        message: '名字长度过长'
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    placeholder="请填写" 
                                                ></Input>      
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                    <Col span={10}>
                                        <Form.Item label="职务/职级">
                                        { 
                                            getFieldDecorator('duty',{
                                                rules :[
                                                    {
                                                        max : 100 ,
                                                        message: '名字长度过长'
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    placeholder="请填写" 
                                                ></Input>             
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={10}>
                                    <Form.Item label="性别">
                                        { 
                                            getFieldDecorator('sex' ,{
                                                rules :[
                                                    {
                                                        max : 2 ,
                                                        message: '请输入合法的性别'
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    placeholder="请填写" 
                                                ></Input>      
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                    <Col span={10}>
                                        <Form.Item label="学位/职称">
                                        { 
                                            getFieldDecorator('degree' ,{
                                                rules :[
                                                    {
                                                        max : 100 ,
                                                        message: '名字长度过长'
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    placeholder="请填写" 
                                                ></Input>             
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                </Row> 
                                <Row gutter={24}>
                                    <Col span={10}>
                                    <Form.Item label="手机">
                                        { 
                                            getFieldDecorator('tel',{
                                                rules :[
                                                    {
                                                        pattern :  /^[1][3,4,5,7,8][0-9]{9}$/ ,
                                                        message : '请输入合法的手机号'
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    placeholder="请填写" 
                                                ></Input>      
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                    <Col span={10}>
                                        <Form.Item label="电子邮箱">
                                        { 
                                            getFieldDecorator('organizationPrincipalEmail' ,{
                                                rules : [
                                                    {
                                                        pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                                                        message: '请输入正确的邮箱格式'
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    placeholder="请填写" 
                                                ></Input>             
                                            )
                                        }
                                        </Form.Item>
                                    </Col>
                                </Row>  
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={4}>
                            <div style={{ color:'black',marginTop:'10px'}}>
                                机构性质（打“√”）
                            </div>
                            </Col>
                            <Col span={20}>
                            <Form.Item label="">
                                { 
                                    getFieldDecorator('organizationNature')(
                                        <Checkbox.Group
                                            style={{paddingTop: 10, paddingBottom: 10 }}
                                            value={this.state.organizationNature.main}
                                            options={a}
                                            onChange={(options) => {
                                                const flg = options.some(option => option === 5)
                                                this.setState({
                                                    organizationNature: {
                                                    ...this.state.organizationNature,
                                                    other: flg,
                                                    main: options
                                                }
                                            })
                                            }}
                                        />  
                                    )
                                }
                                </Form.Item>
                                {
                                    this.state.organizationNature.other ?
                                    <Form.Item labelCol={{ span: 2 }} wrapperCol={{ span: 6 }} label="具体说明：">
                                        {
                                            getFieldDecorator('organizationNatureOther',{
                                                rules :[
                                                    {
                                                        max : 200 ,
                                                        message : '内容不能过长'
                                                    }
                                                ]
                                            })( <Input
                                                value={this.state.organizationNature.text}
                                                placeholder="请填写"
                                                onChange={(event) => {
                                                    this.setState({
                                                        organizationNature: {
                                                            ...this.state.organizationNature,
                                                            text: event.target.value
                                                        }
                                                    })
                                                }}
                                            ></Input>)
                                        } 
                                    </Form.Item> : ""
        
                                }
                            </Col>
                        </Row>
                        
                        <Row gutter={24}>
                            <Col span={4}>
                                <div className="entry-label" style={{color:'black'}} >
                                    机构职责（200字内）
                                </div>
                            </Col>
                            <Col span={20}>
                            <Form.Item label="">
                                { 
                                    getFieldDecorator('organizationResponsibity' , {
                                        rules : [
                                            {
                                                max : 200 ,
                                                message : '机构职责内容应在200字之内'
                                            }
                                        ]
                                    })(
                                        <Input.TextArea
                                        className = "entry-textarea"
                                        rows="5" 
                                        placeholder="请填写"
                                    />
                                    )
                                }
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={4}>
                                <div className="entry-label" style={{color:'black'}}>
                                    目前开展的主要工作（200字内）
                                </div>
                            </Col>
                            <Col span={20}>
                            <Form.Item label="">
                                { 
                                    getFieldDecorator('presentMainWork' , {
                                        rules : [
                                            {
                                                max : 200 ,
                                                message : '目前开展的主要工作内容应在200字之内'
                                            }
                                        ]
                                    })(
                                        <Input.TextArea
                                        className = "entry-textarea"
                                        rows="5" 
                                        placeholder="请填写"
                                    />
                                    )
                                }
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={4}>
                                <div className="entry-label" style={{color:'black'}}>
                                    特色项目（工作特色）
                                </div>
                            </Col>
                            <Col span={20}>
                            <Form.Item label="">
                                { 
                                    getFieldDecorator('workFeather' , {
                                        rules : [
                                            {
                                                max : 200 ,
                                                message : '特色项目内容应在200字之内'
                                            }
                                        ]
                                    })(
                                        <Input.TextArea
                                        className = "entry-textarea"
                                        rows="5" 
                                        placeholder="请填写"
                                    />
                                    )
                                }
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={4}>
                                <div  className="entry-label" style={{color:'black'}}>
                                    院校意见
                                </div>
                            </Col>
                            <Col span={20}>
                                <Form.Item label="">
                                    { 
                                        getFieldDecorator('schoolSuggestion', {
                                            rules : [
                                                {
                                                    max : 200 ,
                                                    message : ' 院校意见应在200字之内'
                                                }
                                            ]
                                        })(
                                            <Input.TextArea 
                                                className = "entry-textarea"
                                                rows="5" 
                                                placeholder="请填写"
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={4}>
                                <div className="entry-label" style={{color:'black'}}>
                                    秘书处意见
                                </div>
                            </Col>
                            <Col span={20}>
                                <Form.Item label="">
                                    <Input.TextArea
                                        disabled={true}
                                        className = "entry-textarea  entry-textarea-end"
                                        rows="5" 
                                        placeholder="本栏由秘书处审核填写"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                  
                    <Form.Item>
                        <div className="register-ciqa-button">
                            <Button 
                                style={{marginRight: 30}} 
                                onClick={() => {
                                    window.location.hash = "/";
                                    window.location.reload();
                                }}
                            >返回</Button>
                            <Button onClick={this.handleOk.bind(this)} type="primary">注册</Button>
                        </div>
                    </Form.Item>
                    </Form>
                </Spin>
            </div>
        )
    }
}

export default Form.create({})(Register)
